import { SecurityElement } from './security-element.model';

export class UserSecurityElement {
  public Element: SecurityElement;
  public AccessLevel: number;

  public constructor() {
    this.Element = new SecurityElement();
    this.AccessLevel = 0;
  }
}
